import $ from "jquery";

/******************************************/
/*************** PUBLICATIONS *************/
/******************************************/
$(function() {
    $('.bloc-newsletter__form').each(function(){
        let $bloc = $(this);
        let $formSubscribe = $(this).find('form.subscribe');
        let $formUnsubscribe = $(this).find('form.unsubscribe');

        let subscribe = true;

        $formSubscribe.submit(function(){
            let $form = $(this);
            $bloc.addClass('loading');
            $.post(ajaxurl, {
                'action': 'subscribe_newsletter',
                'lang' : _lang,
                'data' : getFormData($form)
            }, function(response) {  
                if(response.type == 'success'){
                    $bloc.html($('<div class="text-success">'+response.message+'</div>'));
                }   
                else
                    processForm($form, response.errors);                
                $bloc.removeClass('loading');
            });
            return false;
        });

        $formUnsubscribe.submit(function(){
            let $form = $(this);
            $bloc.addClass('loading');
            $.post(ajaxurl, {
                'action': 'unsubscribe_newsletter',
                'lang' : _lang,
                'data' : getFormData($form)
            }, function(response) {  
                if(response.type == 'success'){
                    $bloc.html($('<div class="text-success">'+response.message+'</div>'));
                }   
                else
                    processForm($form, response.errors);                
                $bloc.removeClass('loading');
            });
            return false;
        });

        $(this).find('a.toggle-subscribe').click(function(e){
            e.preventDefault();
            subscribe = !subscribe;
            $formSubscribe.toggle(subscribe);
            $formUnsubscribe.toggle(!subscribe);
            let toggleText = $(this).data('toggle');
            $(this).data('toggle', $(this).html()).html(toggleText);
        });
    });
});

function getFormData($form){
    let data = {};
    $form.find('input[name]').each(function(){
        if(['checkbox','radio'].includes($(this)[0].type) == false || $(this).is(':checked')){
            data[$(this)[0].name] = $(this).val(); 
        }
    });
    return data;
}

function processForm($form, errors){
    $form.find('input[name]').each(function(){
        let name = $(this)[0].name;
        let $parent = $(this).parent();        
        let $error = $parent.find('.invalid-feedback');
        if(errors[name] !== undefined){
            if($error.length == 0){
                $error = $('<div class="invalid-feedback">xxxx</div>');
                $parent.append($error);
            }
            $error.html(errors[name][0]);      
            $(this).addClass('is-invalid'); 
        }
        else{
            $error.remove();
            $(this).removeClass('is-invalid');  
        }            
    });
}